import { useRef, useEffect, useState } from "react";
import _ from "lodash";
import { Col, Row, Statistic } from 'antd';
import { useDataStore } from "../../../store";

const cancelOrderRe = /授权资金解冻|订单驳回|订单取消/;
//@todo 增加table展示详细订单数据

//租赁平台详细数据统计
export function LeaseDetailModule (){
    //在租平台数
    //申请次数
    //取消次数
    //在租台数
    //已支付金额
    //剩余总债权
    const content = useDataStore( state => state.content );
    //使用英文作为key
    const [data, setData] = useState({
        'leasingPlatformCount': 0,
        'applicationCount': 0,
        'cancellationCount': 0,
        'inUseCount': 0,
        'paidAmount': 0,
        'remainingDebt': 0
    });
    const dataKeyMap = {
        'leasingPlatformCount': '在租平台数',
        'applicationCount': '申请次数',
        'cancellationCount': '取消次数',
        'inUseCount': '在租台数',
        'paidAmount': '已支付金额',
        'remainingDebt': '剩余总债权'
    }

    useEffect(() => {

        let partyData = {};

        content.forEach( item => {
            if( item.SCENE === 'Lease' ){
                let _data = _.get( partyData, item.PARTY, {
                    "paidment": 0,
                    "count": 0,
                    "flow": 0
                });
                if( item._IE === 1 ) {
                    _data.paidment += item.AMOUNT;
                    _data.count += 1;
                    _.set(partyData, item.PARTY, _data);
                }
                _data.flow += 1;
                //取消次数
                if( cancelOrderRe.test(item.TYPE) || (item._IE === 0 && item.SCENE === 'Lease')){
                    data.cancellationCount = data.cancellationCount + 1;
                }
            }
        });

        //在租平台数
        //如果paidment大于1, 且count大于1，则认为是一个在租平台
        _.entries( partyData ).forEach(([party, item]) => {
            if( item.paidment > 1 && item.count > 1 || item.paidment > 1000 ){
                // data.current.leasingPlatformCount += 1;
                data.leasingPlatformCount = data.leasingPlatformCount + 1;
                //按13000计算总价 - 已还金额为剩余债权
                let remainingDebt = _.round((13000 - item.paidment), 2);
                // data.current.remainingDebt = _.round(data.current.remainingDebt + remainingDebt, 2);
                data.remainingDebt = _.round(data.remainingDebt + remainingDebt, 2);
                //已支付/订单数是平均订单支付金额，除1000取整，是在租台数
                let avgPayment = item.paidment / item.count;
                if( item.count === 1 ) {
                    data.inUseCount += 1;
                } else {
                    let t = Math.max(Math.floor(avgPayment / 1000), 1);
                    data.inUseCount += t;
                }
            }
            //申请次数
            if( item.flow > 0 ){
                data.applicationCount += 1;
            }
            data.paidAmount = _.round(data.paidAmount + item.paidment, 2);
        });

        setData({...data});

    }, [ content ]);

    return <Row direction="hozizontal" gutter={[24, 24]} style={{ marginBottom: '24px' }}>
        {Object.entries(data).map(([key, value]) => {
            return <Col span={4} key={key}>
                <Statistic title={dataKeyMap[key]} value={value} />
            </Col>
        })}
    </Row>
}
